import { SchedulesResponse } from "../../models/PlanSchedule";
import {
  FETCH_SCHEDULES_REQUEST,
  FETCH_SCHEDULES_SUCCESS,
  FETCH_SCHEDULES_FAILURE,
  FETCH_SCHEDULES_LOADING,
} from "../types";

interface SchedulesState {
  loading: boolean;
  data: SchedulesResponse | null;
  error: string | null;
}

const initialState: SchedulesState = {
  loading: false,
  data: null,
  error: null,
};

const recurringPlanSchedulesReducer = (
  state = initialState,
  action: any
): SchedulesState => {
  switch (action.type) {
    case FETCH_SCHEDULES_LOADING:
      return { ...state, loading: action.payload };

    case FETCH_SCHEDULES_REQUEST:
      return { ...state, error: null };

    case FETCH_SCHEDULES_SUCCESS:
      return { ...state, data: action.payload, error: null };

    case FETCH_SCHEDULES_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default recurringPlanSchedulesReducer;
